import type { CallScriptContext, CallScriptSegment, CallScriptToken } from "@/model/interface/Call";

export const SCRIPT_TOKENS: CallScriptToken[] = [
  { key: "firstName", label: "First name" },
  { key: "lastName", label: "Last name" },
  { key: "company", label: "Company" },
  { key: "propertyAddress", label: "Property address" },
  { key: "dealStage", label: "Deal stage" },
  { key: "agentName", label: "Agent name" },
  { key: "businessName", label: "Business name" },
];

const TOKEN_PATTERN = /\{\{(\w+)\}\}/g;

export function tokenText(token: CallScriptToken): string {
  return `{{${token.key}}}`;
}

export function resolveScript(body: string, context: CallScriptContext): CallScriptSegment[] {
  const segments: CallScriptSegment[] = [];
  let lastIndex = 0;
  Array.from(body.matchAll(TOKEN_PATTERN)).forEach((match) => {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      segments.push({ text: body.slice(lastIndex, matchIndex), isToken: false, isResolved: false });
    }
    const token = SCRIPT_TOKENS.find((candidate) => candidate.key === match[1]);
    const value = token ? context[token.key] : null;
    if (value) {
      segments.push({ text: value, isToken: true, isResolved: true });
    } else {
      segments.push({ text: token?.label ?? match[0], isToken: true, isResolved: false });
    }
    lastIndex = matchIndex + match[0].length;
  });
  if (lastIndex < body.length) {
    segments.push({ text: body.slice(lastIndex), isToken: false, isResolved: false });
  }
  return segments;
}
